/**
 * @generated SignedSource<<45fe94ec08e1bee33d0a2768c3cdbd64>>
 * @relayHash 4287cfc47f1fea41c9ebc20fb6e0356c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2a00a5217999d1f6bf48b73e0f9a048209a3ae6d62640010ed30c8e4e28013fe

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type updateHideDoneToggleOldMutation$variables = {
  isHideDoneEnabled: boolean;
  viewId: string;
};
export type updateHideDoneToggleOldMutation$data = {
  readonly jira: {
    readonly updateIssueSearchHideDonePreference: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type updateHideDoneToggleOldMutation = {
  response: updateHideDoneToggleOldMutation$data;
  variables: updateHideDoneToggleOldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHideDoneEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "isHideDoneEnabled",
    "variableName": "isHideDoneEnabled"
  },
  {
    "kind": "Variable",
    "name": "viewId",
    "variableName": "viewId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "updateHideDoneToggleOldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
            "kind": "LinkedField",
            "name": "updateIssueSearchHideDonePreference",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "updateHideDoneToggleOldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
            "kind": "LinkedField",
            "name": "updateIssueSearchHideDonePreference",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2a00a5217999d1f6bf48b73e0f9a048209a3ae6d62640010ed30c8e4e28013fe",
    "metadata": {},
    "name": "updateHideDoneToggleOldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "30139df1d842375cd25b05794a1cf0e8";

export default node;
